import { useSession } from '@hooks/useSession'
import { Redirect } from 'expo-router'
import Home from './home'

export default function Index() {
  const { logged } = useSession()
  if (logged) {
    return <Home />
  }
  return <Redirect href="/users/sign_in" />
}
